module.exports = __webpack_public_path__ + "static/rudiman-134da136075e54fe2647f16d8f27fbb5.png";